import React from 'react';
import { motion } from 'framer-motion';
import { Clock, Home, Cake } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const ExpiredWish = () => {
    const navigate = useNavigate();

    return (
        <div className="min-h-screen bg-gradient-to-br from-gray-100 to-gray-200 flex items-center justify-center p-6">
            <motion.div
                initial={{ scale: 0.5, opacity: 0 }}
                animate={{ scale: 1, opacity: 1 }}
                transition={{ duration: 0.8, type: "spring", stiffness: 120 }}
                className="max-w-md w-full text-center"
            >
                <motion.div
                    initial={{ rotate: 0 }}
                    animate={{ rotate: [0, -10, 10, 0] }}
                    transition={{ duration: 2, repeat: Infinity }}
                    className="mb-8"
                >
                    <div className=" bg-gradient-to-r from-purple-600 to-pink-600 text-white py-3 rounded-xl font-semibold flex items-center justify-center gap-2 shadow-lg hover:shadow-xl transition-all duration-300 w-24 h-24 flex items-center justify-center mx-auto mb-6 shadow-xl">
                        <Clock className="w-12 h-12 text-white" />
                    </div>
                </motion.div>

                <motion.div
                    initial={{ y: 50, opacity: 0 }}
                    animate={{ y: 0, opacity: 1 }}
                    transition={{ delay: 0.3, duration: 0.8 }}
                    className="bg-white rounded-3xl p-8 shadow-2xl"
                >
                    <h1 className="text-4xl font-bold text-gray-800 mb-4">
                        Wish Expired
                    </h1>

                    <p className="text-lg text-gray-600 mb-6 leading-relaxed">
                        This special wish QR code has expired after 24 hours. All wishes are temporary to make each moment extra special!
                    </p>

                    <div className="bg-gradient-to-r from-orange-100 to-red-100 rounded-2xl p-4 mb-6">
                        <p className="text-sm text-gray-700">
                            💡 <strong>Tip:</strong> Create new wish QR codes through our portal for fresh celebrations!
                        </p>
                    </div>

                    <motion.button
                        whileHover={{ scale: 1.05, boxShadow: "0 10px 25px rgba(0,0,0,0.1)" }}
                        whileTap={{ scale: 0.95 }}
                        onClick={() => navigate('/')}
                        className="w-full bg-gradient-to-r from-purple-600 to-pink-600 text-white py-3 rounded-xl font-semibold flex items-center justify-center gap-2 shadow-lg hover:shadow-xl transition-all duration-300"
                    >
                        <Home className="w-5 h-5" />
                        Back to Keek Colombo
                    </motion.button>
                </motion.div>

                <motion.div
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    transition={{ delay: 0.6, duration: 0.8 }}
                    className="mt-6 text-center"
                >
                    <div className="flex items-center justify-center gap-2 text-gray-500">
                        <Cake className="w-4 h-4" />
                        <span className="text-sm font-medium">Keek Colombo - Sweet Wishes</span>
                    </div>
                </motion.div>
            </motion.div>
        </div>
    );
};

export default ExpiredWish;